import React from 'react';
import videoSrc from './hero-background.mp4';
import './VideoBackground.css';

const VideoBackground = () => {
  return (
    <div className="video-container">
      <video
        className="video-bg"
        src={videoSrc}
        autoPlay
        muted
        loop
        playsInline
      />
      <div className="video-overlay" />
      <div className="video-content">
        <h1 className="hero-title">emily motyka</h1>
        <p className="hero-subtitle">dream pop and colors</p>
      </div>

          </div>
  );
};

export default VideoBackground;
